var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageAccepted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.222 31.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 48.5a48.372 48.372 0 0 1-3.523 18.18l-.015.038v.001a48.287 48.287 0 0 1-6.14 10.854 47.914 47.914 0 0 1-2.067 2.571 48.503 48.503 0 0 1-3.868 4.002l-.181.167a48.474 48.474 0 0 1-3.968 3.257 47.112 47.112 0 0 1-4.633 3.025 45.558 45.558 0 0 1-2.14 1.156 36.372 36.372 0 0 1-1.077.531c-.2.098-.405.192-.608.287a48.055 48.055 0 0 1-8.245 2.926l-.046.011a35.202 35.202 0 0 1-.979.237 29.182 29.182 0 0 1-.921.204l-.49.102c-.1.021-.2.04-.3.058l-.372.072a37.604 37.604 0 0 1-1.485.253 40.915 40.915 0 0 1-1.275.178 1554.885 1554.885 0 0 0-.435.055 27.622 27.622 0 0 1-.753.082c-.163.018-.327.033-.49.048a45.404 45.404 0 0 1-1.91.138 47.645 47.645 0 0 1-1.93.063h-.005a48.817 48.817 0 0 1-12.492-1.454c-.136-.034-.271-.07-.408-.106a48.12 48.12 0 0 1-10.13-3.902l-.049-.025c-.093-.05-.185-.097-.277-.147a48.323 48.323 0 0 1-4.765-2.891l-.26-.18a43.923 43.923 0 0 1-.976-.7A48.75 48.75 0 0 1 6.128 72.117 48.27 48.27 0 0 1 0 48.5C0 21.715 21.715 0 48.5 0 75.286 0 97 21.715 97 48.5Z",
    fill: "#5E667D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.612 32.504c.916 5.165-1.106 9.842-1.106 9.842s-3.505-3.697-4.42-8.863c-.916-5.165 1.105-9.842 1.105-9.842s3.505 3.698 4.421 8.863Z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.13 76.95.25.09c-.025.187-.084.302-.25-.09Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.432 77.01c.003.02.008.042.01.062l-.107-.032c.003-.018.005-.038.01-.058.025-.252-.005-.549.087.028Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9EA6B5",
    cx: 44.724,
    cy: 46.583,
    r: 23.563
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F7F8",
    cx: 46.663,
    cy: 54.916,
    r: 14.269
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.246 82.265-.017.004-3.32.797L69 84.724l-.943.227-10.509 2.521-.892.215-25.497 6.119a47.874 47.874 0 0 1-5.044-2.272l-.049-.025c-.093-.05-.185-.097-.277-.147a48.323 48.323 0 0 1-4.765-2.891l-.26-.18a43.923 43.923 0 0 1-.976-.7c2.477-4.501 8.375-7.493 14.272-9.13 4.451-1.237 5.43-5.302 5.345-8.92a21.086 21.086 0 0 0-.21-2.465c-.18-1.3-.465-2.583-.855-3.837l14.27.477 1.473 3.392a7.79 7.79 0 0 0-.039 1.122c.112 2.782 1.83 4.582 3.949 5.743.276.15.558.29.845.421 3.476 1.58 7.566 1.688 7.566 1.688a14.567 14.567 0 0 1 3.744.07 12.647 12.647 0 0 1 5.486 2.227c.528.376 1.027.79 1.494 1.238.83.777 1.543 1.668 2.119 2.648Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.387 84.146-.181.167a48.474 48.474 0 0 1-3.968 3.257 47.112 47.112 0 0 1-4.633 3.025 45.558 45.558 0 0 1-2.14 1.156 36.372 36.372 0 0 1-1.077.531l-.607-.504 7.129-8.712 1.433-1.752s.573 0 1.886.955a18.99 18.99 0 0 1 2.052 1.77c.034.037.07.071.106.107Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.286 84.048a1.65 1.65 0 0 1-.08.265 48.474 48.474 0 0 1-3.968 3.257 16.925 16.925 0 0 1-3.7.88s.107.539.205 1.472a46.734 46.734 0 0 1-2.655 1.506c-.206.11-.414.217-.622.323a36.372 36.372 0 0 1-1.078.531c-.2.098-.405.192-.608.287a48.055 48.055 0 0 1-8.245 2.926l-.046.011a35.202 35.202 0 0 1-.979.237 29.182 29.182 0 0 1-.921.204l-.49.102c-.1.021-.2.04-.3.058l-.372.072a37.604 37.604 0 0 1-1.485.253 40.915 40.915 0 0 1-1.275.178 1554.885 1554.885 0 0 0-.435.055 27.622 27.622 0 0 1-.753.082c-.163.018-.327.033-.49.048a45.404 45.404 0 0 1-1.91.138 47.645 47.645 0 0 1-1.93.063h-.005a48.666 48.666 0 0 1-12.492-1.454c-.136-.034-.271-.07-.408-.106a48.12 48.12 0 0 1-10.13-3.902l-.049-.025c-.093-.05-.185-.097-.277-.147a10503.145 10503.145 0 0 1 32.026-7.415 3113.63 3113.63 0 0 1 11.848-2.697c3.397-.763 6.034-1.343 7.465-1.633.385-.088.775-.156 1.168-.205l2.986 4.628.005.008Z",
    fill: "#BDC1CB"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9EA6B5",
    cx: 23.167,
    cy: 29.538,
    r: 7.019
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9EA6B5",
    cx: 66.281,
    cy: 27.533,
    r: 7.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.761 24.525a7.018 7.018 0 0 1 6.267-6.978 7.019 7.019 0 1 0 0 13.955 7.018 7.018 0 0 1-6.267-6.977Zm-43.437 10.69a7.018 7.018 0 0 1-.407-9.37 7.019 7.019 0 1 0 9.766 9.968 7.018 7.018 0 0 1-9.359-.598Zm29.4.339c-8.307 0-15.04 3.928-15.04 8.773 0 2.168 1.353 4.15 3.588 5.68l2.895-2.098-.787 3.287c.326.151.66.298 1.008.433l4.325-5.046v6.2a25.29 25.29 0 0 0 4.01.317c8.307 0 15.04-3.928 15.04-8.773s-6.733-8.773-15.04-8.773Z",
    fill: "#9EA6B5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F8",
    transform: "rotate(-15.639 32.632 57.77)",
    cx: 32.632,
    cy: 57.77,
    rx: 1.189,
    ry: 2.854
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F8",
    transform: "rotate(-86.476 61.17 55.392)",
    cx: 61.171,
    cy: 55.392,
    rx: 2.854,
    ry: 1.189
  })), /*#__PURE__*/React.createElement("path", {
    d: "m202.616 118.395-2.459-2.826a2 2 0 0 1-.483-1.495l.342-3.732a2 2 0 0 0-1.546-2.133l-3.61-.824a2 2 0 0 1-1.278-.936l-1.892-3.218a2 2 0 0 0-2.517-.823l-3.384 1.46a2 2 0 0 1-1.585 0l-3.387-1.461a2 2 0 0 0-2.515.82l-1.889 3.204a2 2 0 0 1-1.283.935l-3.602.813a2 2 0 0 0-1.552 2.133l.343 3.747a2 2 0 0 1-.48 1.492l-2.466 2.844a2 2 0 0 0 .002 2.623l2.461 2.828a2 2 0 0 1 .483 1.495l-.343 3.75a2 2 0 0 0 1.547 2.132l3.61.824a2 2 0 0 1 1.279.934l1.887 3.203a2 2 0 0 0 2.52.819l3.383-1.47a2 2 0 0 1 1.59-.002l3.384 1.46a2 2 0 0 0 2.515-.82l1.89-3.207a2 2 0 0 1 1.278-.934l3.61-.824a2 2 0 0 0 1.547-2.133l-.342-3.732a2 2 0 0 1 .483-1.495l2.459-2.826a2 2 0 0 0 0-2.625Z",
    fill: "#8CD062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.554 126.787-4.037-4.241a1.812 1.812 0 0 1 0-2.492l.119-.124a1.661 1.661 0 0 1 2.408 0l2.73 2.863 8.736-9.118a1.661 1.661 0 0 1 2.408 0l.119.123c.661.69.661 1.803 0 2.492l-10.04 10.497c-.696.69-1.765.69-2.443 0Z",
    fill: "#FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageAccepted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-accepted.4525d2c286146ddff15f16ea9d686a77.svg";